// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579694328346
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorPage/ErrorPage.scss
// module id = ./src/components/ErrorPage/ErrorPage.scss
// module chunks = 0